(function () {
  if (customElements.get('scroll-carousel')) return;

  class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.dotsNav = this.querySelector('[data-carousel-dots]');
      this.step = this.getAttribute('data-step') || 'page';
      this.autoplayMs = parseInt(this.getAttribute('data-autoplay') || '0', 10);
      this.slides = Array.from(this.track.children);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.move(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.move(1));

      this._onScroll = this._debounce(() => this._update(), 80);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      // Re-evaluate arrow states when the carousel actually gets a size — e.g.
      // it was initialized while hidden (recently-viewed is injected, then shown).
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(this._onScroll);
        this._resizeObserver.observe(this.track);
      }

      this._buildDots();
      this._update();

      if (this.autoplayMs > 0 && this.slides.length > 1) {
        this._start();
        this.addEventListener('mouseenter', () => this._stop());
        this.addEventListener('mouseleave', () => this._start());
        this.addEventListener('focusin', () => this._stop());
      }
    }

    disconnectedCallback() {
      this._stop();
      this._resizeObserver?.disconnect();
    }

    _stepWidth() {
      if (this.step === 'item' && this.slides[0]) {
        const cs = getComputedStyle(this.track);
        const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return this.slides[0].getBoundingClientRect().width + gap;
      }
      return this.track.clientWidth;
    }

    move(dir) {
      this.track.scrollBy({ left: dir * this._stepWidth(), behavior: 'smooth' });
    }

    _index() {
      const w = this._stepWidth();
      return w ? Math.round(this.track.scrollLeft / w) : 0;
    }

    _atEnd() {
      return Math.ceil(this.track.scrollLeft + this.track.clientWidth) >= this.track.scrollWidth - 1;
    }

    _buildDots() {
      if (!this.dotsNav || this.slides.length < 2) return;
      this.dotsNav.innerHTML = '';
      this.dots = this.slides.map((_, i) => {
        const li = document.createElement('li');
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => {
          this.track.scrollTo({ left: i * this._stepWidth(), behavior: 'smooth' });
        });
        li.appendChild(b);
        this.dotsNav.appendChild(li);
        return b;
      });
    }

    _update() {
      const idx = this._index();
      if (this.dots) {
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      }
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = this._atEnd();
    }

    _start() {
      this._stop();
      this._timer = setInterval(() => {
        if (this._atEnd()) this.track.scrollTo({ left: 0, behavior: 'smooth' });
        else this.move(1);
      }, this.autoplayMs);
    }

    _stop() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    _debounce(fn, ms) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }
  }

  // Guarded: more than one section on a page can use the carousel, and each
  // loads this script, so define() would otherwise throw on the second run.
  if (!customElements.get('scroll-carousel')) {
    customElements.define('scroll-carousel', ScrollCarousel);
  }
})();
